import dayjs from 'dayjs'
import { ActivityLog } from 'types/graphql'

/**
 * Talk time of a call in seconds, derived from the start/end timestamps and
 * falling back to the stored `callDuration`. Returns `NaN` when neither is
 * available (e.g. hand-logged calls, which never capture talk time).
 */
export const getCallDurationSeconds = (
  activityLog: Pick<
    ActivityLog,
    'startCallDate' | 'endCallDate' | 'callDuration'
  >
): number => {
  if (activityLog.startCallDate && activityLog.endCallDate) {
    return dayjs(activityLog.endCallDate).diff(
      dayjs(activityLog.startCallDate),
      'seconds'
    )
  }
  return activityLog.callDuration != null
    ? Number(activityLog.callDuration)
    : NaN
}

/** Compact talk-time label, e.g. `4m 12s` or `18s`. */
export const formatCallDuration = (seconds: number): string => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`
}
